import { Assert } from '@cotera/utilities';
import type { StreamSpecifier } from '@cotera/api';
import {
  streamIdFromSpecifier,
  entityNameFromSpecifier,
} from '../dg/commit/event-stream-helpers';

export const streamSpecifierToEventStreamIds = (
  specifier: StreamSpecifier
): { streamId: string; entityName: string } => {
  switch (specifier.t) {
    case 'manifest':
      return {
        streamId: specifier.id,
        entityName: specifier.entityName,
      };
    case 'graph':
      return {
        streamId: streamIdFromSpecifier(specifier),
        entityName: entityNameFromSpecifier(specifier),
      };
    default:
      return Assert.unreachable(specifier);
  }
};
